import type { DurationInMinutes } from "@@/shared/date-time/time-spans";
import type { Provider } from "@@/shared/providers/provider";
import { getProviderPrepTime } from "@@/shared/providers/provider";
import type { Shipping } from "../shipping/shipping";
import { isLoopShipping } from "../shipping/shipping-types/loop-shipping";

/*

Cutoff : antal minuter innan vi stänger en slot
pickUpTime : Upphämtingstid av våra chafförer
customPickUpTime : Tid
prepTime: hur lång tid det tar göra maten.

actualPickup

cutoff: prepTime +  actualPickup > Cutoff ? prepTime +  actualPickup : Cutoff


*/
const cutOffByProvider = (provider: Provider, shipping: Shipping) => {
    if (isLoopShipping(shipping)) {
        const cutOff = shipping.options.cutOff;
        const pickUp =
            provider.options.customPickupTime ?? shipping.options.pickupTime;
        const prepTime = getProviderPrepTime(provider);
        const providerCutOff = (pickUp + prepTime) as DurationInMinutes;
        return providerCutOff > cutOff ? providerCutOff : cutOff;
    } else {
        return -1 as DurationInMinutes;
    }
};

const pickupTimeByProvider = (provider: Provider, shipping: Shipping) => {
    if (isLoopShipping(shipping)) {
        return provider.options.customPickupTime ?? shipping.options.pickupTime;
    } else {
        return -1 as DurationInMinutes;
    }
};

export { cutOffByProvider, pickupTimeByProvider };
